import React, { Component } from 'react'
import { Modal, Button } from 'antd'

export default class extends Component {
  state = {
    loading: false
  }

  handleOk = () => {
    if (this.props.id) {
      this.setState({
        loading: true
      })

      this.props.deleteGroup(this.props.id).then((response) => {
        if (response && !response.data.error) {
          this.props.getUsers()

          this.props.updateTable({
            searchGroups: [
              ...this.props.table.searchGroups.filter(item => item !== this.props.id)
            ],
            keys: [],
            rows: []
          })

          this.handleCancel()
        }

        this.setState({
          loading: false
        })
      })
    }
  }

  handleCancel = () => {
    this.setState({
      loading: false
    })
    this.props.closeModal()
  }

  render () {
    return (
      <Modal
        wrapClassName='vertical-center-modal'
        width={320}
        visible={this.props.status}
        onCancel={this.handleCancel}
        destroyOnClose
        footer={[
          <Button key='back' onClick={this.handleCancel}>Cancel</Button>,
          <Button key='submit' type='red' loading={this.state.loading} onClick={this.handleOk}>Delete</Button>
        ]}
      >
        <h4>Are you sure you want to delete this group?</h4>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/GroupDeleteModal/GroupDeleteModal.jsx